// Source: app/scripts/services/stomp.js
/**
 * Created by riste_000 on 3/25/2015.
 */


Auction.factory("Stomp", ['$timeout', function ($timeout) {

  var SOCKET_URL = "/portal/bidding";

  var service = {}, socket = {
    client: null,
    stomp: null,
    listeners: {},
    initialized: false
  }, subscriptions = {};

  service.RECONNECT_TIMEOUT = 30000;


  socket.client = new SockJS(SOCKET_URL);
  socket.stomp = Stomp.over(socket.client);


  function subscribe(topic_id) {
    if (subscriptions[topic_id])
      return;

    subscriptions[topic_id] = socket.stomp.subscribe(topic_id, function (data) {
      var jsonData = data.body.trim();
      if (jsonData.indexOf('{') == 0 || jsonData.indexOf('[') == 0) {
        jsonData = JSON.parse(data.body);
      }

      angular.forEach(socket.listeners[topic_id], function (listener) {
        listener(jsonData);
      });
    });
  }

  var initialize = function () {
    // socket.stomp.debug = null;
    socket.stomp.connect({}, function (frame) {

      socket.reconnect = true;
      socket.initialized = true;
      angular.forEach(socket.listeners, function (listeners, topic_id) {
        // subscribe for each topic_id
        subscribe(topic_id);
      });

    });
    socket.client.onclose = function () {
      socket.initialized = false;
      if (socket.reconnect) {
        $timeout(function () {
          initialize();
        }, service.RECONNECT_TIMEOUT);
      }
    };
  };

  initialize();

  return function (topicUrl, topic_id, listener, scope) {
    topic_id = topicUrl + topic_id;
    socket.listeners[topic_id] = socket.listeners[topic_id] || [];
    socket.listeners[topic_id].push(listener);
    if (socket.initialized) {
      subscribe(topic_id)
    }
    if (scope) {
      scope.$on('$destroy', function () {
        unsubscribe(topic_id);
      });
    }

    function unsubscribe(topic_id) {

      for (var i = 0; i < socket.listeners[topic_id].length; i++) {
        if (socket.listeners[topic_id][i] === listener) {
          socket.listeners[topic_id].splice(i, 1);
          break;
        }
      }
      if (socket.listeners[topic_id].length == 0) {
        var subscription = subscriptions[topic_id];
        if (subscription && typeof subscription.unsubscribe === 'function') {
          subscription.unsubscribe();
        } else {
          socket.stomp.unsubscribe(subscription);
        }
        delete subscriptions[topic_id];
      }
    }


    return {
      unsubscribe: unsubscribe
    }
  };
}]);
